module.exports = __webpack_public_path__ + "static/media/dakika_icon.33106e3c.png";